
// chat.service.ts
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, ReplaySubject, of } from 'rxjs';
import { ApiService } from 'src/app/core/api/api.service';
import { environment } from 'src/environments/environment';



@Injectable({ providedIn: 'root' })
export class GridService {

  public BaseURL: string = `${environment.baseUrls.serviceURL}`;
  public logOutURL: string = `${environment.baseUrls.serviceSecurity}`;
  public requestData: object = {};
  private distinctCache = new Map<string, string[]>();
  private distinctInFlight = new Map<string, ReplaySubject<string[]>>();
  constructor(private apiService: ApiService, private _http: HttpClient) {}
 
getDistinctValues(yearId: string, columnName: string): Observable<string[]> {
  const key = `${yearId}__${columnName}`;

  const cached = this.distinctCache.get(key);
  if (cached) {
    return of(cached);
  }

  const inFlight = this.distinctInFlight.get(key);
  if (inFlight) {
    return inFlight.asObservable();
  }

  const subject = new ReplaySubject<string[]>(1);
  this.distinctInFlight.set(key, subject);

  this.apiService
    .get<string[]>(
      this.BaseURL + `/cmt/PartsComponent/distinctValues/${yearId}/${columnName}`
    )
    .subscribe({
      next: (values) => {
        const safe = (values || []).map((v) => String(v));
        this.distinctCache.set(key, safe);
        subject.next(safe);
        subject.complete();
        this.distinctInFlight.delete(key);
      },
      error: (err) => {
        subject.error(err);
        this.distinctInFlight.delete(key);
      },
    });

  return subject.asObservable();
}

}
